import React, { Fragment } from 'react'
import Card from 'react-bootstrap/Card'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import DetailsButton from 'components/DetailsButton'
import Moment from 'react-moment'
import 'moment/locale/ar'
import ReadMoreReact from 'read-more-react'
import i18n from 'i18n'
import stringDelimiter from '../../../CampaignSystem/utils/stringDelimiter'
import { RTL } from '../../../locales/currentLang'
const CampaignCard = styled(Card)`
  border: 1px solid #ebebeb !important;
  border-radius: 15px !important;
  width: 100%;
  height: 100%;
  padding-bottom: 1em;
  display: block;
  min-width: auto;
  box-shadow: none !important;
  background-size: auto;
  background: #ffffff url(${props => props.src}) no-repeat center 1em;
  background-size: 9em 6em;
`
const Title = styled(Card.Title)`
  color: #212529;
  font-weight: bold;
  text-align: center;
  font-size: 1em;
  line-height: 1.188em;
  margin-top: 7.313em;
  height: 7vh;
  .read-more-button {
    color: #212529 !important;
    font-weight: bold;
    font-size: 1em;
  }
`
const DeadLine = styled(Card.Body)`
  color: #777777;
  font-size: 0.75em;
  line-height: 0.938em;
  text-align: center;
`
const InterestText = styled.p`
  margin-bottom: 0;
  line-height: 1em;

  height: 0.8em;
  overflow: hidden;
  color: #797979;
`
export default function CampaignComponent(props) {
  const { src, deadline, title, path, campaign, interests, from } = props
  return (
    <CampaignCard src={src} {...props}>
      <Title>
        <ReadMoreReact
          text={title}
          readMoreText="..."
          max={40}
          min={10}
          ideal={30}
        />
      </Title>
      {interests?.length > 0 && (
        <InterestText className="text-center">
          {interests.map((interest, index) => (
            <Fragment key={index}>
              {interest}
              {index < interests.length - 1 ? ' , ' : null}
            </Fragment>
          ))}
        </InterestText>
      )}

      <DeadLine>
        {i18n.t('general.starts')}{' '}
        <Moment
          fromNow
          ago
          locale={stringDelimiter(localStorage.getItem('i18nextLng'))}
        >
          {deadline}
        </Moment>
      </DeadLine>
      <DetailsButton
        title={i18n.t('general.details')}
        path={path}
        campaign={campaign}
        from={from}
        width={RTL() ? '8em' : '7.25em'}
      />
    </CampaignCard>
  )
}

CampaignComponent.propTypes = {
  src: PropTypes.string,
  width: PropTypes.string,
  title: PropTypes.string,
  deadline: PropTypes.string,
  path: PropTypes.any,
  campaign: PropTypes.object,
  interests: PropTypes.array,
  from: PropTypes.any,
}
CampaignComponent.defaultProps = {
  path: '/',
  from: '/',
}
